import { cn } from '@/utils/styles';
import { CANCER_DETECT_PATH, HOME_PATH } from '@/constants/paths';
import { useLocation } from 'react-router-dom';
import { Link, linkVariants, type LinkProps } from '@design-system/Link';

export interface DashboardLayoutNavItemProps
  extends Omit<LinkProps, 'to' | 'children'> {
  to: string;
  label?: React.ReactNode;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  activeIcon: React.FC<React.SVGProps<SVGSVGElement>>;
  external?: boolean;
}

const getIsActive = (pathname: string, to: string) => {
  return (to === HOME_PATH ? pathname === to : pathname.includes(to)) || (pathname === CANCER_DETECT_PATH && to === '/');
};

export const DashboardLayoutNavItem = ({
  to,
  icon,
  label,
  external,
  className,
  activeIcon,
}: DashboardLayoutNavItemProps) => {
  const { pathname } = useLocation();
  const isActive = !external && getIsActive(pathname, to);

  const IconComponent = isActive ? activeIcon : icon;

  const content = (
    <>
      {IconComponent && (
        <IconComponent width={24} height={24} className="!size-6" aria-hidden />
      )}
      {label && <span className="typography-body">{label}</span>}
    </>
  );

  if (external) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(linkVariants({ variant: 'default' }), 'justify-start', className)}
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      to={to}
      data-active={isActive}
      className={cn('justify-start', className)}
    >
      {content}
    </Link>
  );
};
